import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "@/lib/useSEO";
import LegalPageLayout, { LegalSection } from "@/components/LegalPageLayout";

export default function TermsPage() {
  useSEO({
    title: "Terms & Conditions — KARM",
    description: "The terms that govern your use of KARM.",
    path: "/terms",
  });

  return (
    <LegalPageLayout eyebrow="Legal" title="Terms & Conditions" updated="22 July 2026">
      <LegalSection heading="1. Acceptance of Terms">
        <p>
          By creating an account or using karm.day ("KARM", "the Service"), you agree to these
          Terms. If you don't agree, please don't use the Service.
        </p>
      </LegalSection>

      <LegalSection heading="2. What KARM Provides">
        <p>
          KARM curates and displays job listings for roles at
          Global Capability Centres worldwide. Listings link out to the employer's own careers
          site or Applicant Tracking System — clicking "Apply" takes you off KARM to complete
          your application directly with the employer.
        </p>
      </LegalSection>

      <LegalSection heading="3. No Guarantee on Listings">
        <p>
          We make reasonable efforts to keep listings accurate and current, but job postings can
          close, change, or be removed by the employer at any time without notice. KARM is not
          the employer, is not a recruitment agency, and does not guarantee interviews, offers,
          or employment outcomes.
        </p>
      </LegalSection>

      <LegalSection heading="4. Your Account">
        <p>
          You're responsible for the accuracy of the information you provide (including your
          resume) and for keeping your login credentials secure. You must be 18 or older to
          create an account.
        </p>
      </LegalSection>

      <LegalSection heading="5. Acceptable Use">
        <p>
          Don't scrape, resell, or republish KARM's listings at scale, attempt to breach
          security, upload malicious files, or misuse the platform to harass employers or other
          users.
        </p>
      </LegalSection>

      <LegalSection heading="6. Paid Features">
        <p>
          Optional paid features ("KARM Plus") are billed on a recurring basis until cancelled.
          You can cancel anytime from your account; fees already charged for the current billing
          period are non-refundable except where required by law.
        </p>
      </LegalSection>

      <LegalSection heading="7. Intellectual Property">
        <p>
          The KARM name, logo, and site design are our property. Job listing content belongs to
          the respective employers.
        </p>
      </LegalSection>

      <LegalSection heading="8. Disclaimer &amp; Limitation of Liability">
        <p>
          The Service is provided "as is" without warranties of any kind. To the fullest extent
          permitted by law, KARM is not liable for any indirect or consequential damages arising
          from your use of the Service or any third-party employer's hiring process.
        </p>
      </LegalSection>

      <LegalSection heading="9. Governing Law">
        <p>These Terms are governed by the laws of India.</p>
      </LegalSection>

      <LegalSection heading="10. Changes to These Terms">
        <p>
          We may update these Terms from time to time; continued use of KARM after an update
          means you accept the revised Terms.
        </p>
      </LegalSection>

      <LegalSection heading="11. Contact">
        <p>
          Questions about these Terms? Reach us at{" "}
          <a href="mailto:hello@karm.day" className="underline text-foreground">hello@karm.day</a>{" "}
          or visit our <Link to="/contact" className="underline text-foreground">Contact page</Link>.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
